import {
  Button,
  Col,
  Dropdown,
  MenuProps,
  notification,
  Row,
  Switch,
  Tag,
} from 'antd';
import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import axiosInstance from '../../../../../../../axios_instance';
import {
  IsAdminContext,
  NumberOfProjectsContext,
  UserProjectsDataContext,
} from '../../../../../../../context';
import DeleteModal from '../../../../../modal/delete';
import EditProject from '../edit-project';
import styles from './styles.module.scss';

interface ProjectDetailProps {
  technology: Array<any>;
  project_id: number;
  project_name: string;
  score: number;
  company_name: string;
  contribution: string;
  description: string;
  end_date: string;
  start_date: string;
  show_in_resume: boolean;
  companyOptions: any;
}

const ProjectDetail: React.FC<ProjectDetailProps> = ({
  project_id,
  project_name,
  technology,
  company_name,
  contribution,
  description,
  end_date,
  start_date,
  show_in_resume,
  companyOptions,
}: ProjectDetailProps): JSX.Element => {
  const [iseditable, setIsEditable] = useState<boolean>(false);
  const { userProjectData, setUserProjectData } = useContext(
    UserProjectsDataContext
  );
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const isAdmin = useContext(IsAdminContext);
  const { employeeId } = useParams();
  const { numberOfProjects, setNumberOfProjects } = useContext(
    NumberOfProjectsContext
  );
  const [isSubmitted, setIsSubmitted] = useState<boolean>(false);

  console.log('details, contribution', contribution);

  const openNotification = (
    notificationType: 'success' | 'info' | 'warning' | 'error',
    Project_name: string
  ) => {
    notification[notificationType]({
      message:
        notificationType === 'info'
          ? `Deleting Project ${Project_name}`
          : notificationType === 'success'
          ? `Deleted Project ${Project_name} Successfully`
          : notificationType === 'error'
          ? `An error occured while deleting Project ${Project_name}`
          : '',
    });
  };

  const handleDelete = () => {
    openNotification('info', project_name);
    let reqBody = {};
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/projects';
      reqBody = { profile_id: employeeId, project_id, status: 3 };
    } else {
      url = '/api/v1/profile/projects';
      reqBody = { project_id, status: 3 };
    }
    axiosInstance
      .post(url, reqBody)
      .then((response) => {
        let userProjects: Array<any> = [];
        if (response.data.projects.length !== 0) {
          userProjects = response.data.projects.filter(
            (project: any) => project['status']['id'] === 1
          );
          const orderedProjects = response.data.order && response.data.order.length > 0
            ? response.data.order
                .map((projectId: number) =>
                  userProjects.find((userProject: any) => userProject.project_id === projectId)
                )
                .filter((item: any) => item !== undefined)
            : userProjects;

          setUserProjectData(orderedProjects);
          setNumberOfProjects(orderedProjects.length);
        } else {
          setUserProjectData(response.data.projects);
          setNumberOfProjects(0);
        }
        openNotification('success', project_name);
      })
      .catch((error) => {
        console.log(error);
        openNotification('error', project_name);
      });
  };

  const items: MenuProps['items'] = [
    {
      label: (
        <div
          onClick={(e) => {
            setIsEditable(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Edit</p>
        </div>
      ),
      key: '0',
    },
    {
      label: (
        <div
          onClick={() => {
            setIsDeleteModalOpen(true);
          }}
          style={{ width: '60px', margin: '0px', padding: '5px' }}
        >
          <p>Delete</p>
        </div>
      ),
      key: '1',
    },
  ];

  const handleChangeResume = (value: any) => {
    const formData: any = {
      show_in_resume: value,
      project_id: project_id,
    };
    let url = '';
    if (isAdmin === '1') {
      url = '/api/v1/admin/profile/projects';
      formData.profile_id = employeeId;
    } else {
      url = '/api/v1/profile/projects';
    }
    axiosInstance
      .post(url, formData)
      .then((response) => {
        const userProjects = response.data.projects.filter(
          (Project: any) => Project['status']['id'] === 1
        );
        const orderedProjects = response.data.order && response.data.order.length > 0
          ? response.data.order
              .map((projectId: number) =>
                userProjects.find((userProject: any) => userProject.project_id === projectId)
              )
              .filter((item: any) => item !== undefined)
            : userProjects;
        setUserProjectData(orderedProjects);
        setIsEditable(false);
        setNumberOfProjects(orderedProjects.length);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsSubmitted(false);
      });
  };

  return (
    <div>
      {isDeleteModalOpen ? (
        <DeleteModal
          {...{
            isModalOpen: isDeleteModalOpen,
            setIsModalOpen: setIsDeleteModalOpen,
            handleDelete: handleDelete,
          }}
        />
      ) : (
        <></>
      )}
      {iseditable ? (
        <EditProject
          {...{
            project_id,
            project_name,
            company_name,
            contribution,
            description,
            end_date,
            technology,
            start_date,
            setIsEditable,
            show_in_resume,
            companyOptions,
          }}
        />
      ) : (
        <Row key={project_id} className={styles.row} gutter={{ xs: 8, sm: 16 }}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              position: 'absolute',
              bottom: '5px',
              right: '5px',
            }}
          >
            <Switch defaultChecked onChange={handleChangeResume} />
            <span style={{ paddingLeft: '5px' }}>Show in resume</span>
          </div>
          <Col span={12}>
            <Row>
              <h3 className={styles['Project-text']}>
                <b>{project_name}</b>
              </h3>
            </Row>
            <Row>
              <p style={{ padding: '0px' }}>
                <span className={styles.title}>Description : </span>
                <span
                  className={styles.value}
                  dangerouslySetInnerHTML={{ __html: description }}
                />
              </p>
            </Row>
            <Row>
              <p style={{ padding: '0px' }}>
                <span className={styles.title}>My Contribution : </span>
                <span
                  className={styles.value}
                  dangerouslySetInnerHTML={{ __html: contribution }}
                />
              </p>
            </Row>
          </Col>
          <Col span={11}>
            <Row>
              <Col span={12}>
                <p>
                  <span className={styles.title}>Company : </span>
                  <span className={styles.value}>{company_name}</span>
                </p>
              </Col>
            </Row>
            {technology &&
              technology.filter((tech: any) => tech && tech.skill_name && tech.skill_id != null).length > 0 && (
                <Row>
                  <Col span={24}>
                    <p>
                      <span className={styles.title}>Technology : </span>
                      <span className={styles.value}>
                        {technology
                          .filter((tech: any) => tech && tech.skill_name && tech.skill_id != null)
                          .map((tech) => (
                            <Tag key={tech.skill_id} color="blue">
                              {tech.skill_name}
                            </Tag>
                          ))}
                      </span>
                    </p>
                  </Col>
                </Row>
              )}
            <Row>
              <Col span={12}>
                <p>
                  <span className={styles.title}>Start Date : </span>
                  <span className={styles.value}>{start_date}</span>
                </p>
              </Col>
              <Col span={12}>
                <p>
                  <span className={styles.title}>End Date : </span>
                  <span className={styles.value}>{end_date}</span>
                </p>
              </Col>
            </Row>
          </Col>
          <Dropdown menu={{ items }} trigger={['click']} placement="bottomLeft">
            <Button
              type="text"
              style={{
                position: 'absolute',
                right: '5px',
                border: 'hidden',
                textDecoration: 'blue',
                top: '10px',
              }}
            >
              <img
                src="/more_vert.png"
                style={{
                  marginLeft: 'auto',
                  marginRight: '0px',
                  height: '15px',
                  width: '5px',
                  fontWeight: '600',
                  cursor: 'pointer',
                }}
              />
            </Button>
          </Dropdown>
        </Row>
      )}
    </div>
  );
};

export default ProjectDetail;
